import React from "react";
import "./App.css";
import { usePaths } from "./BEDROCK/paths";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LandingPage } from "./BEDROCK/pages/landing/landing-page";
import { AuthPage } from "BEDROCK/pages/auth/supabase/auth-page";
import { PosterEditor } from "PosterEditor/PosterEditor";
import { ProjectListPage } from "project-list/project-list-page";
import { TemplateListAdmin } from "admin/templates-admin/template-list-admin";
import { CollectionsListAdmin } from "admin/collections-admin/collections-list-admin";
import { CollectionDetailAdmin } from "admin/collections-admin/collection-detail-admin";
import { Checkout } from "BEDROCK/pages/checkout/checkout";
import { CheckoutConfirmation } from "BEDROCK/pages/checkout/checkout-confirmation";
import { PostCheckout } from "BEDROCK/pages/checkout/post-checkout";
import { ProtectedRoute } from "BEDROCK/auth/projected-route";
import { ProcessOrder } from "process-order/process-order";

function App() {
  const paths = usePaths();

  return (
    <Routes>
      <Route path={paths.home} element={<LandingPage />} />
      <Route path={paths.signUp} element={<AuthPage authContext="signup" />} />
      <Route path={paths.signIn} element={<AuthPage authContext="signin" />} />
      <Route
        path={paths.changePassword}
        element={<AuthPage authContext="changePassword" />}
      />
      <Route
        path={paths.confirmEmail}
        element={<AuthPage authContext="confirm" />}
      />
      <Route
        path={paths.resetPassword}
        element={<AuthPage authContext="resetPassword" />}
      />
      <Route
        path={paths.confirmResetPassword}
        element={<AuthPage authContext="confirmResetPassword" />}
      />
      {/* <Route path={paths.formExamples} element={<FormExamples />} /> */}
      {/* <Route path="*" element={<NotFound />} /> */}
      <Route path={paths.landing} element={<LandingPage />} />

      <Route path={paths.mapEditor} element={<PosterEditor />} />
      <Route
        path={`${paths.mapEditor}/:projectId`}
        element={<PosterEditor />}
      />
      <Route
        path={`${paths.templateEditor}/:templateId`}
        element={<PosterEditor />}
      />
      <Route
        path={paths.projectList}
        element={
          <ProtectedRoute>
            <ProjectListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.templateListAdmin}
        element={
          <ProtectedRoute>
            <TemplateListAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.collectionsAdmin}
        element={
          <ProtectedRoute>
            <CollectionsListAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${paths.collectionEditAdmin}/:collectionId`}
        element={
          <ProtectedRoute>
            <CollectionDetailAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${paths.processOrder}/:projectId`}
        element={
          <ProtectedRoute>
            <ProcessOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.checkout}
        element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.checkoutConfirmation}
        element={
          <ProtectedRoute>
            <CheckoutConfirmation />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.postCheckout}
        element={
          <ProtectedRoute>
            <PostCheckout />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
